import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishPagination } from './pagination';
import { FishPaginationConfig } from './pagination-config';

export { FishPagination } from './pagination';
export { FishPaginationConfig } from './pagination-config';


export class FishPaginationModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishPaginationModule, providers: [FishPaginationConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FishPagination],
  exports: [FishPagination],
  imports: [CommonModule]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
